import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthPageShell } from '../layout/auth-page-shell';

@Component({
  selector: 'lib-auth-password-reset-page',
  imports: [RouterModule, AuthPageShell],
  template: `
    <lib-auth-page-shell>
      <router-outlet />
    </lib-auth-page-shell>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordResetPage {}
